import { translate } from "shared/languages";
import PATHS from "shared/constants/paths";
import PendapatanProdukPromoContent from "./PendapatanProdukPromoContent";

const SalesPackagesPromoPage = () => (
  <PendapatanProdukPromoContent
    type="paket"
    title={translate("analyticsPage.package.report_pendapatan_produk_promo")}
    backTo={PATHS.ANALYTICS}
  />
);

export default SalesPackagesPromoPage;
